export default function ErrorMessageInputField () {

return (
  <div className='error-message'>Input fields cannot be empty. Set to 0 if necessary.</div>
)

}